<template>
  <slot />
</template>
<script>
export default {
  data() {
    return {
      showNav: false,
    };
  },
};
</script>
